<template>
  <p>影像库</p >
</template>

<script>
  export default {
    name: "MainImageLibrary"
  }
</script>

<style scoped>

</style>
